import {Component, OnInit, ViewChild} from '@angular/core';
import {RestApiService} from '../../rest-api.service';
import {NotifierService} from 'angular-notifier';
import {MessageService} from '../../message.service';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {FormControl} from '@angular/forms';
import {AngularGridInstance, Column, Formatters, GridOption} from 'angular-slickgrid';

@Component({
  selector: 'app-access-specifiers',
  templateUrl: './access-specifiers.component.html',
  styleUrls: ['./access-specifiers.component.css']
})
export class AccessSpecifiersComponent implements OnInit {
  radioButton: any;
  displayed = false;

  ticketTypes: any;
  name: string;
  brief: string;
  rDate = '';
  dDate = '';
  clientId: any;
  private notifier: NotifierService;
  respObject: any;

  radioChecked: any;
  cat = [];
  attachment = [];
  uploadButtonName = 'Upload File';
  fileUploadUrl: string;
  add = false;
  public clientName: string;
  private typeSeq: number | string | any;
  groups = [];
  supportGroupSelected = [];
  users = [];
  userSelected = [];
  download: boolean;
  upload: boolean;
  deleted: boolean;
  emailSearch: string;
  textSelected: any;
  isLoading = false;
  searchTerm: FormControl = new FormControl();
  docs = [];
  columnDefinitions: Column[];
  gridOptions: GridOption;
  dataset = [];
  angularGrid: AngularGridInstance;
  gridObj: any;
  @ViewChild('content') private content;
  private modalReference: NgbModalRef;
  docuId: any;
  title: string;
  desc: string;
  creator: string;
  categories = [];
  actions = [];
  sGroups = [];
  sUsers = [];
  formData: any;
  attachments = [];
  comment: string;
  comments = [];
  comLoaded: boolean;
  delete: boolean;
  added = [];

  angularGridReady(angularGrid: AngularGridInstance) {
    this.angularGrid = angularGrid;
    this.gridObj = angularGrid && angularGrid.slickGrid || {};
    const classes = document.getElementsByClassName('search-filter');
    for (let i = 0; i < classes.length; i++) {
      classes[i].setAttribute('placeholder', '');
    }
  }

  constructor(private _rest: RestApiService, notifier: NotifierService,
              private messageService: MessageService, private modalService: NgbModal) {
    this.notifier = notifier;
    this.searchTerm.valueChanges.subscribe(
      word => {
        console.log(typeof word);
        // if (word.length > 3) {
        this.isLoading = true;
        this._rest.searchDocuId(this.clientId, word).subscribe((res1) => {
          this.respObject = res1;
          this.isLoading = false;
          if (this.respObject.success) {
            this.docs = this.respObject.details;
          } else {
            this.docs = [];
          }
        }, (err) => {
          this.isLoading = false;
        });
        // }
      });
  }

  ngOnInit() {
    this.columnDefinitions = [
      {
        id: 'delete',
        field: 'id',
        excludeFromHeaderMenu: true,
        formatter: Formatters.deleteIcon,
        minWidth: 30,
        maxWidth: 30,
      },
      {id: 'id', name: 'Id', field: 'id', minWidth: 50, sortable: true, filterable: true},
      {id: 'user', name: 'User', field: 'NAME', minWidth: 100, sortable: true, filterable: true},
      {
        id: 'grp', name: 'Group', field: 'groupName', minWidth: 100, sortable: true, filterable: true
      },
      {
        id: 'action', name: 'Action', field: 'action', minWidth: 100, sortable: true, filterable: true
      }
    ];
    this.gridOptions = {
      enableAutoResize: true,       // true by default
      enableCellNavigation: true,
      enableFiltering: true,
      editable: true,
      rowSelectionOptions: {
        selectActiveRow: false
      },
      enableCheckboxSelector: true,
      enableRowSelection: true
    };
    this._rest.getDocuActions().subscribe((res) => {
      this.respObject = res;
      if (this.respObject.success) {
        this.actions = this.respObject.details;
      } else {
        this.notifier.notify('error', this.respObject.errorMessage);
      }
    }, (err) => {
      this.notifier.notify('error', this.messageService.SERVER_ERROR);
    });
    this._rest.getUserdetails(this.messageService.getUserId()).subscribe((res) => {
      this.respObject = res;
      if (this.respObject.success) {
        this.clientId = this.respObject.details[0].clientId;
        this.clientName = this.respObject.details[0].client;
        // this._rest.getTicketType(this.clientId).subscribe((res1) => {
        //   this.respObject = res1;
        //   // console.log('ticket type=', JSON.stringify(this.respObject));
        //   if (this.respObject.success) {
        //     // this.radioChecked = this.respObject.details[0].id;
        //     for (let i = 0; i < this.respObject.details.length; i++) {
        //       if (this.respObject.details[i].seq === this.messageService.DOCU_TYPE) {
        //         this.radioChecked = this.respObject.details[i].id;
        //         break;
        //       }
        //     }
        //     // console.log('this.displayed:' + this.displayed);
        //     this.typeSeq = this.respObject.details[0].seq;
        //     this.radioButton = this.respObject.details;
        //     // this.getTicketLoadingData();
        //   } else {
        //     this.notifier.notify('error', this.respObject.errorMessage);
        //   }
        // }, (err) => {
        //   this.notifier.notify('error', this.messageService.SERVER_ERROR);
        // });
      } else {
        this.notifier.notify('error', this.respObject.errorMessage);
      }
    }, (err) => {
      this.notifier.notify('error', this.messageService.SERVER_ERROR);
    });
  }

  get selectedOptions() {
    return this.actions
      .filter(opt => opt.checked)
      .map(opt => opt.id);

  }

  checkAll(checked: boolean, index: any) {
    if (this.actions[index].id === 4) {
      if (checked) {
        for (let i = 0; i < this.actions.length; i++) {
          this.actions[i].checked = true;
        }
      } else {
        for (let i = 0; i < this.actions.length; i++) {
          this.actions[i].checked = false;
        }
      }
    } else {
      if (!checked) {
        for (let i = 0; i < this.actions.length; i++) {
          if (this.actions[i].id === 4) {
            this.actions[i].checked = false;
            break;
          }
        }
      }
    }
    // console.log(checked, JSON.stringify(this.actions[i]), i);
  }

  onCellClicked(e: any, args: any) {
    const selectedRow = this.angularGrid.gridService.getColumnFromEventArguments(args);
    const data = selectedRow.dataContext;
    if (selectedRow.columnDef.id === 'delete') {
      // console.log(JSON.stringify(metadata.columnDef));
      // console.log(JSON.stringify(metadata.dataContext));
      selectedRow.dataContext.type = 'delete';
      // this.messageService.setCellChangeData(metadata.dataContext);
      const data1 = {
        id: data.id,
        user_id: this.messageService.getUserId()
      };
      if (confirm('Are you sure to delete the permission?')) {
        this._rest.deleteActionDocumentWise(data1).subscribe((res) => {
          this.respObject = res;
          if (this.respObject.success) {
            this.angularGrid.gridService.deleteDataGridItemById(data.id);
          } else {
            this.notifier.notify('error', this.respObject.errorMessage);
          }
        }, (err) => {
          this.notifier.notify('error', this.respObject.errorMessage);
        });
      }
    }
  }

  addDocu() {
    if (this.selectedOptions.length > 0) {

      // if (this.sUsers.length > 0) {
      //   for (let i = 0; i < this.sUsers.length; i++) {
      //     for (let j = 0; j < this.selectedOptions.length; j++) {
      //       const a = {};
      //       if (this.selectedOptions[j].id !== 4) {
      //
      //         a['actionId'] = this.selectedOptions[j].id;
      //         a['actionName'] = this.selectedOptions[j].action;
      //         a['userId'] = this.sUsers[i].userId;
      //         a['uname'] = this.sUsers[i].uname;
      //         a['groupId'] = this.sUsers[i].groupId;
      //         // console.log('after:' + JSON.stringify(this.sUsers[i]));
      //         this.added.push(a);
      //         // console.log(JSON.stringify(this.added));
      //       }
      //     }
      //
      //   }
      // }
      const allActions = [];
      for (let j = 0; j < this.selectedOptions.length; j++) {
        if (this.selectedOptions[j] !== 4) {
          allActions.push(this.selectedOptions[j]);
        }
      }
      const data = {
        'search_id': this.textSelected,
        'actions': allActions,
        'users': this.sUsers,
        'clientId': this.clientId,
        'createdBy': this.messageService.getUserId()
      };
      this._rest.addUserActionDocumentWise(data).subscribe((res1) => {
        this.respObject = res1;
        if (this.respObject.success) {
          this.notifier.notify('success', 'Successfully added permission to users');
          this.getActionsByDocumentId();
        } else {
          this.notifier.notify('error', this.respObject.errorMessage);
        }
      }, (err) => {
        this.notifier.notify('error', this.messageService.SERVER_ERROR);
      });
    } else {
      this.notifier.notify('error', this.messageService.BLANK_ACTION);
    }
  }

  onUserChange() {
    this.sUsers = [];
    if (this.userSelected.indexOf(0) > -1) {
      this.userSelected = [];
      for (let i = 0; i < this.users.length; i++) {
        if (this.users[i].id !== 0) {
          // this.sUsers.push({userId: this.users[i].id, groupId: this.users[i].groupId, uname: this.users[i].name});
          this.sUsers.push(this.users[i].id);
          this.users[i].isDisabled = true;
        }
        this.userSelected.push(this.users[i].id);
      }
    } else {
      for (let i = 0; i < this.users.length; i++) {
        if (this.users[i].id !== 0) {
          this.users[i].isDisabled = false;
        }
        // for (let j = 0; j < this.userSelected.length; j++) {
        //   if (this.userSelected[j] === this.users[i].id) {
        //     this.sUsers.push({userId: this.users[i].id, groupId: this.users[i].groupId, uname: this.users[i].name});
        //   }
        // }
      }
      for (let i = 0; i < this.userSelected.length; i++) {
        this.sUsers.push(this.userSelected[i]);
      }
    }
  }

  onGroupChange() {
    this.sGroups = [];
    this.userSelected = [];
    if (this.supportGroupSelected.indexOf(0) > -1) {
      this.supportGroupSelected = [];
      for (let i = 0; i < this.groups.length; i++) {
        if (this.groups[i].id !== 0) {
          this.sGroups.push(this.groups[i].id);
          this.groups[i].isDisabled = true;
        }
        this.supportGroupSelected.push(this.groups[i].id);
      }
    } else {
      for (let i = 0; i < this.groups.length; i++) {
        if (this.groups[i].id !== 0) {
          this.groups[i].isDisabled = false;
        }
      }
      for (let i = 0; i < this.supportGroupSelected.length; i++) {
        this.sGroups.push(this.supportGroupSelected[i]);
      }
    }
    console.log(JSON.stringify(this.supportGroupSelected));
    if (this.sGroups.length > 0) {
      this._rest.getUsersByMultiGroup(this.clientId, this.sGroups).subscribe((res1) => {
        this.respObject = res1;
        if (this.respObject.success) {
          this.respObject.details.unshift({id: 0, name: 'All User'});
          this.users = this.respObject.details;
          // console.log(JSON.stringify(this.users));
          // this.userSelected = 0;
        } else {
          this.notifier.notify('error', this.respObject.errorMessage);
        }
      }, (err) => {
        this.notifier.notify('error', this.messageService.SERVER_ERROR);
      });
    } else {
      this.users = [];
    }
  }

  documentSearch() {
    this._rest.getGroupsByDocument(this.clientId).subscribe((res1) => {
      this.respObject = res1;
      if (this.respObject.success) {
        this.respObject.details.unshift({id: 0, name: 'All Groups'});
        this.groups = this.respObject.details;
        // this.supportGroupSelected = 0;
      } else {
        this.notifier.notify('error', this.respObject.errorMessage);
      }
    }, (err) => {
      this.notifier.notify('error', this.messageService.SERVER_ERROR);
    });
    this.getActionsByDocumentId();
  }

  getActionsByDocumentId() {
    this._rest.getActionsByDocument(this.textSelected, this.clientId).subscribe((res1) => {
      this.respObject = res1;
      if (this.respObject.success) {
        // this.respObject.details.unshift({id: 0, name: 'All Groups'});
        // this.groups = this.respObject.details;
        // this.supportGroupSelected = 0;
        this.dataset = this.respObject.details;
      } else {
        this.notifier.notify('error', this.respObject.errorMessage);
      }
    }, (err) => {
      this.notifier.notify('error', this.messageService.SERVER_ERROR);
    });
  }

  docSelected() {
    this._rest.getGroupsByDocument(this.clientId).subscribe((res1) => {
      this.respObject = res1;
      if (this.respObject.success) {
        this.respObject.details.unshift({id: 0, name: 'All Groups'});
        this.groups = this.respObject.details;
        // this.supportGroupSelected = 0;
      } else {
        this.notifier.notify('error', this.respObject.errorMessage);
      }
    }, (err) => {
      this.notifier.notify('error', this.messageService.SERVER_ERROR);
    });
    this.getActionsByDocumentId();
  }
}
